import type { ColorGroup } from '../../interfaces';

export const COLORS_MAPPING: Record<ColorGroup, string> = {
  brown: '#7E5B45',
  red: '#CD463F',
  purple: '#B459D9',
  pink: '#F8A4B3',
  yellow: '#FAE366',
  green: '#73C074',
  orange: '#E9844D',
  blue: '#3F9BF0',
  beige: '#DBC9AF',
  grey: '#B7B7B7',
  black: '#000000',
  white: '#FFFFFF',
  multicolor: 'multicolor',
  transparent: 'transparent',
  silver: 'silver',
  golden: 'golden',
  copper: 'copper',
  other: 'other',
};
